import EventPage from 'organization/Event/EventPage'
import BreadcrumMenu from 'organization/theme/Breadcrum'
import React from 'react'
import {LocalLink} from 'i18n/LocalLink'
import ZapierLogo from 'organization/Event/Integrations/Zapier/zapier.webp'
import CsvImportLogo from 'organization/Event/Integrations/CsvImport/csvimport.png'
import {useOrganizationEventRoutes} from 'organization/OrganizationRoutes'
import {EventFaqHelp} from 'organization/Event/Help/FAQ'
import {useI18n} from 'i18n/I18nContext'

export const Integrations = () => {
  const {t} = useI18n()
  const routes = useOrganizationEventRoutes()

  return (
    <EventPage>
      <>
        <div className="row pl-30 pb-30 pr-30">
          <BreadcrumMenu
            title={t('orgIntegrations.title')}
            helpInfo={<EventFaqHelp faqKey="integrationsPage" />}
          />

          <div className="event__venue-area">
            <div className="row">
              <div
                key={'zapier'}
                className="col-xxl-4 col-xl-6 col-lg-6 col-md-6"
              >
                <div className="speaker__list-item mb-30">
                  <div>
                    <LocalLink to={routes.integrations.zapier}>
                      <img
                        style={{width: '100%', height: 'auto'}}
                        src={ZapierLogo}
                        alt=" not found"
                      />
                    </LocalLink>
                  </div>
                  <div className="speaker__list-content-inner">
                    <div className="speaker__list-content">
                      <h5 className="speaker__author-title">
                        <LocalLink to={routes.integrations.zapier}>
                          Zapier
                        </LocalLink>
                      </h5>
                      <span className="speaker__author-info">
                        {t('orgIntegrations.notLinked')}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div key={'csv'} className="col-xxl-4 col-xl-6 col-lg-6 col-md-6">
                <div className="speaker__list-item mb-30">
                  <div>
                    <LocalLink to={routes.integrations.csvImport}>
                      <img
                        style={{width: '100%', height: 'auto'}}
                        src={CsvImportLogo}
                        alt=" not found"
                      />
                    </LocalLink>
                  </div>
                  <div className="speaker__list-content-inner">
                    <div className="speaker__list-content">
                      <h5 className="speaker__author-title">
                        <LocalLink to={routes.integrations.csvImport}>
                          {t('orgIntegrations.csvTitle')}
                        </LocalLink>
                      </h5>
                      <span className="speaker__author-info">
                        {t('orgIntegrations.noPending')}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </EventPage>
  )
}
